import { gql } from '@urql/core';

export const PERMISSION_LIST_QUERY = gql`
  query PermissionList {
    permissions {
      nodes {
        id
        organizationalRoles
        resources
        actions
      }
    }
  }
`;

export const PERMISSION_ONE_QUERY = gql`
  query PermissionOne($id: String!) {
    permission(id: $id) {
      id
      organizationalRoles
      resources
      actions
    }
  }
`;

export const CREATE_PERMISSION_MUTATION = gql`
  mutation CreatePermission($input: CreatePermissionInput!) {
    createPermission(input: $input) {
      id
      organizationalRoles
      resources
      actions
    }
  }
`;

export const UPDATE_PERMISSION_MUTATION = gql`
  mutation UpdatePermission($id: String!, $input: UpdatePermissionInput!) {
    updatePermission(id: $id, input: $input) {
      id
      organizationalRoles
      resources
      actions
    }
  }
`;

export const DELETE_PERMISSION_MUTATION = gql`
  mutation DeletePermission($id: String!) {
    deletePermission(id: $id) {
      id
      organizationalRoles
      resources
      actions
    }
  }
`;

export const MY_PERMISSIONS_QUERY = gql`
  query MyPermissions {
    myPermissions {
      id
      organizationalRoles
      resources
      actions
    }
  }
`;
